import { render, staticRenderFns } from "./MyPost.vue?vue&type=template&id=778c037d&scoped=true&"
import script from "./MyPost.vue?vue&type=script&lang=js&"
export * from "./MyPost.vue?vue&type=script&lang=js&"
import style0 from "./MyPost.vue?vue&type=style&index=0&id=778c037d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778c037d",
  null
  
)

export default component.exports